<template>
	 <!-- :class='[hidden ? "overflow-hidden whitespace-nowrap" : ""]' -->

	<td ref='td' v-if='visable'>
		<slot />
	</td>
</template>

<script>
	export default {
		props: {
			name: { type: String, default: null },
			width: { type: String, default: null },
			labels: { type: Array, default: null }
		},

		created() {
			this.hidden = ! this.visable
		},

		data() {
			return {
				hidden: this.visable
			}
		},	

		watch: {
			visable() {
				setTimeout(() => {
					this.hidden = ! this.visable;
				}, this.visable ? 500 : 0)
			}
		},

		computed: {
			user() {
				return this.$parent.user;
			},

			visable() {
				if (this.name == null) {
					return true;
				}
				
				if (this.$parent.page == undefined 
					|| this.$parent.page.user == undefined 
					|| this.$parent.page.user.columns == undefined
				) {
					return false;
				}

				return this.$parent.page.user.columns[this.name]
			},
		}
	}
</script>